export default __webpack_public_path__ + "static/bed-bath-beyond-5-cc-a5f7c80e9152e8f70797a94fa992621f.webp";